import React from "react";
import { Chip, Stack, TableCell, TableHead, TableRow, styled, Typography, Avatar } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';

const LegitChip = styled(Chip)(
    ({ theme }) => `
        background: white;
        border-radius: 2px !important;
        color: black;
        font-weight: normal;
        border: 1px solid black;
        font-family: inherit;
        font-size: ${theme.typography.caption.fontSize};
    `
)

const CustomTableCell = styled(TableCell)(
    ({ theme }) => `
        & .MuiTypography-root {
            text-align: center !important;
        }
    ` 
)

const CustomCodeLabel = styled(Avatar)(
    ({ theme }) => `
        background: ${theme.palette.primary.main};
        color: white;
        width: 36px;
        height: 36px;
        font-size: 14px;
    ` 
)


export default function AnzItem({ data, index }) {

    return (
        <TableRow sx={{background: index % 2 == 0 ? "#F4F4F0" : "#FFFFFF"}}>
            <TableCell>
                <Stack>
                    <Typography sx={{textAlign: "right !important"}}>{data?.persian_name}</Typography>
                    <Typography sx={{textAlign: "right !important", opacity: "0.6"}}>{data?.name}</Typography>
                </Stack>
            </TableCell>
            <CustomTableCell>
                <Stack alignItems="center">
                    {data?.group}
                </Stack>
            </CustomTableCell>
            <CustomTableCell>
                <Stack alignItems="center">
                    {data?.anzsco}
                </Stack>
            </CustomTableCell>
            <CustomTableCell>
                <Stack alignItems="center">
                    {data?.skill}
                </Stack>
            </CustomTableCell>
            <CustomTableCell>
                <Stack alignItems="center">
                    {data?.assesing_authority}
                </Stack>
            </CustomTableCell>
        </TableRow>
    );
}

